import * as React from 'react';

import { TextChannelStyles } from '../styles/ChannelStyles';
import { HomeStyles } from '../styles/HomeStyles';
import { ChannelTypes } from '../types/ChannelTypes';
import { ChannelHeader } from './ChannelHeader';

/**
 * Used to change the paragraph display to flex in order to center the text with the icon
 */
const flexCenterItems = {
  display: 'flex',
  alignItems: 'center'
};

interface ITextChannelProps {
  title: string;
}

export class TextChannel extends React.PureComponent<ITextChannelProps> {
  render() {
    return (
      <section className={HomeStyles.contentSection}>
        <ChannelHeader title={this.props.title} channelType={ChannelTypes.text}/>
        <p className={TextChannelStyles.text} style={flexCenterItems}>
          {this.props.children}
        </p>
      </section>
    );
  }
}
